import { FC } from "react";
import { useField } from "formik";
import MaskedInput from "react-text-mask";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

//App
import {
  CreateTextMaskCustomProps,
  MaskedTextboxProps,
} from "../../../../types";

const CreateTextMaskCustom = ({ mask }: CreateTextMaskCustomProps) => {
  const TextMaskCustom: FC<any> = (props) => {
    return (
      <MaskedInput
        {...props}
        mask={mask}
        showMask
        placeholderChar={"\u2000"}
        guide={false}
      />
    );
  };

  return TextMaskCustom;
};

const MaskedTextbox: FC<MaskedTextboxProps> = ({
  label = "",
  placeholder = "",
  maskedfield: MaskedField,
  variant = "filled",
  name,
  value,
  isRequired,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <FormGroup floating>
      <Input
        {...field}
        {...props}
        invalid={meta?.touched && !!meta?.error}
        placeholder={label}
        tag={MaskedField}
      />
      <Label for={name}>{isRequired ? `${label} *` : label}</Label>
      {meta?.touched && meta?.error && (
        <FormFeedback>{meta.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

const maskedPhoneField = CreateTextMaskCustom({
  mask: [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
});

const MaskedPhoneNumberField = (props: any) => {
  return (
    <MaskedTextbox
      maskedfield={maskedPhoneField}
      onKeyDown={(e: any) => {
        let cursorPos = Number(e.target.selectionStart);
        let keyCode = Number(e.keyCode);
        if (
          (cursorPos === 5 || cursorPos === 6 || cursorPos === 10) &&
          keyCode === 8
        ) {
          e.preventDefault();
          e.target.value = e.target.value.substring(
            0,
            e.target.value.length - 1
          );
        }
      }}
      {...props}
    />
  );
};

const maskedZipField = CreateTextMaskCustom({
  mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
});

const maskedCardSecurityCodeField = CreateTextMaskCustom({
  mask: [/\d/, /\d/, /\d/, /\d/],
});

const maskedExpiryDateField = CreateTextMaskCustom({
  mask: [/[0-1]/, /\d/, "/", /[2-9]/, /\d/],
});

const MaskedZipCode = (props: any) => {
  return <MaskedTextbox maskedfield={maskedZipField} {...props} />;
};

const MaskedCardSecurityCode = (props: any) => {
  return <MaskedTextbox maskedfield={maskedCardSecurityCodeField} {...props} />;
};

const MaskedExpiryDate = (props: any) => {
  return (
    <MaskedTextbox
      maskedfield={maskedExpiryDateField}
      {...props}
      placeholder="MM/YY"
    />
  );
};

const numberMask = createNumberMask({
  prefix: "",
  suffix: "",
  includeThousandsSeparator: false,
});

const maskedNumberField = CreateTextMaskCustom({
  mask: numberMask,
});

const MaskedNumber = (props: any) => {
  return <MaskedTextbox maskedfield={maskedNumberField} {...props} />;
};

export {
  MaskedPhoneNumberField,
  MaskedZipCode,
  MaskedCardSecurityCode,
  MaskedExpiryDate,
  MaskedNumber,
};
